// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-input-name-wrap[data-v-368ea87e]{display:flex;gap:15px;justify-content:space-between;align-items:flex-start}", ""]);
// Exports
module.exports = exports;
